import Vue from 'vue';

const CREATE_PRODUCT_TYPE_URL = '/product-type/';
const UPDATE_PRODUCT_TYPE_URL = '/product-type/';
const LIST_PRODUCT_TYPE_URL = '/product-type/list';
const DELETE_PRODUCT_TYPE_URL = '/product-type/';

class ProductTypeDefinitionService {

    async create(data) {
        return await Vue.prototype.$axios.post(CREATE_PRODUCT_TYPE_URL, data);
    }

    async update(data) {
        return await Vue.prototype.$axios.put(UPDATE_PRODUCT_TYPE_URL, data);
    }

    async list() {
        return await Vue.prototype.$axios.get(LIST_PRODUCT_TYPE_URL);
    }

    async delete(id) {
        return await Vue.prototype.$axios.delete(DELETE_PRODUCT_TYPE_URL, {params: {id: id}});
    }
}

export default new ProductTypeDefinitionService();
